<template>
    <div class="mod-register">
        <mini-header :headerTitle="'用户详情'"></mini-header>
        <div class="register-main">
            <div class="mod-title">
                <h1>用户详情</h1>
                <span class="under-line"></span>
            </div>
            <el-form disabled :model="ruleForm" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                <el-divider content-position="left">原账户信息</el-divider>
                <div class="form_panel">
                    <el-form-item label="原用户名" prop="oldUserInfo.name">
                        <el-input v-model="ruleForm.oldUserInfo.name"></el-input>
                    </el-form-item>
                    <el-form-item label="原手机号码" prop="oldUserInfo.phone">
                        <el-input v-model="ruleForm.oldUserInfo.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号" prop="oldUserInfo.qq">
                        <el-input v-model="ruleForm.oldUserInfo.qq" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号" prop="oldUserInfo.wx">
                        <el-input v-model="ruleForm.oldUserInfo.wx" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="头像上传" prop="oldUserInfo.avatar">
                        <el-image :src="getUrl(ruleForm.oldUserInfo.avatar)">
                            <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
                        </el-image>
                    </el-form-item>
                </div>
                <el-divider content-position="left">新账户信息</el-divider>
                <div class="form_panel">
                    <el-form-item label="新用户名" prop="userInfo.name">
                        <el-input v-model="ruleForm.userInfo.name" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="新手机号码" prop="userInfo.phone">
                        <el-input v-model="ruleForm.userInfo.phone" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号" prop="userInfo.qq">
                        <el-input v-model="ruleForm.userInfo.qq" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号" prop="userInfo.wx">
                        <el-input v-model="ruleForm.userInfo.wx" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="头像上传" prop="userInfo.avatar">
                        <el-image :src="getUrl(ruleForm.userInfo.avatar)">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                        </el-image>
                    </el-form-item>
                </div>
            </el-form>
            <div class="btn-control">
                <el-button round @click="$router.push({ name: 'accountMg' })">取消</el-button>
                <el-button type="primary" v-if="ruleForm.userInfo.st == 2" round @click="submitForm">审核</el-button>
            </div>
        </div>
        <main-footer></main-footer>
        <account-pop ref="accountPop"></account-pop>
    </div>
</template>

<script>
import { previewUrl } from "@/utils";
import MiniHeader from "./../common/mini-header.vue";
import MainFooter from "./../main-footer.vue";
import accountPop from "./accountPop.vue"
export default {
    components: {
        MiniHeader,
        MainFooter,
        accountPop
    },
    data() {
        return {
            ruleForm: {}
        };
    },
    mounted(){
        this.$http.get(this.$api.shiroApi.userInfo,{params: { id: this.$route.query.id }}).then(({ data }) => {
            this.ruleForm = data.data
        });
    },
    methods: {
        getUrl(url) {
            return previewUrl(url);
        },
        // 表单提交
        submitForm() {
            this.$refs.accountPop.visible = true;
        },
    }
};
</script>
